/**
 * @deprecated since 4.2 - use order lib instead
 */
export enum AmendOrderType {
  CANCEL,
  RETURN,
}
